/**
 * Generated by orval 🍺
 * Do not edit manually.
 * OnEarly Core API
 * OnEarly Core HTTP API
 * OpenAPI spec version: 0.0.1
 */
import * as zod from 'zod';

export const SearchInstanceHit = zod.object({
  contentTypeUuid: zod.uuid().describe('UUID v4 identifier'),
  cursor: zod.string().describe('Pass as `after` to continue after this row'),
  lineageUuid: zod.uuid().describe('UUID v4 identifier'),
  occurredAt: zod.string(),
  updatedAt: zod.string(),
  uuid: zod.uuid().describe('UUID v4 identifier'),
  variant: zod.enum(['INSTANCE']),
});

export type SearchInstanceHit = zod.input<typeof SearchInstanceHit>;
export type SearchInstanceHitOutput = zod.output<typeof SearchInstanceHit>;
